var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportarBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_1413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0H0V2.2068H7.75V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74403 6.92069C7.74403 7.06716 7.68765 7.21727 7.56508 7.34559L4.43591 10.6189C4.14052 10.9276 3.60612 10.9276 3.31196 10.6189L0.185241 7.34559C-0.225363 6.91706 0.116603 6.25611 0.746604 6.25611C0.96355 6.25611 1.16947 6.34084 1.30919 6.48732L3.02025 8.2777V4.08562C3.02025 3.66436 3.40389 3.32178 3.87578 3.32178C4.11233 3.32178 4.3256 3.40651 4.48004 3.54573C4.6357 3.68373 4.7313 3.87378 4.7313 4.08562V8.27649L6.44236 6.48732C6.58331 6.34084 6.788 6.25611 7.00372 6.25611C7.44497 6.25611 7.74526 6.57932 7.74526 6.92069H7.74403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_1413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.75,
    height: 10.85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportarBlanco);
export default __webpack_public_path__ + "static/media/ExportarBlanco.2f26555e257499a28e8491a08845b52a.svg";
export { ForwardRef as ReactComponent };